export function getTokenScopes(token: string): string[] {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (Array.isArray(payload.scp)) return payload.scp;
        if (typeof payload.scp === "string") return payload.scp.split(" ");
        if (typeof payload.scope === "string") return payload.scope.split(" ");
        return [];
    } catch {
        return [];
    }
}